module.exports = __webpack_public_path__ + "static/media/parallax-form-4.5e605220.svg";